module.exports = "<div class=\"dimmer\">\n  <div class=\"spinner\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/spinner/spinner.html
// module id = 579
// module chunks = 0